<template>
  <div>
    <Row type="flex" class="tai-xiu-history-details-row">
      <Col class="tai-xiu-history-details-row-col">
        <Row type="flex" class="tai-xiu-history-details-table-title-row">
          <Col class="tai-xiu-history-details-table-title">
            {{ $t("general.Dice") }}
          </Col>
          <Col class="tai-xiu-history-details-table-title">
            {{ $t("tai_xiu.dicehistory") }}
          </Col>
        </Row>
        <Row type="flex">
          <Col class="tai-xiu-history-details-table-title">
            <div>
              <img
                :src="
                  require(`../../../assets/images/tai-xiu/assets/dice-1-active.png`)
                "
                width="18%"
              />
            </div>
            <div>
              <img
                :src="
                  require(`../../../assets/images/tai-xiu/assets/dice-2-active.png`)
                "
                width="18%"
              />
            </div>
            <div>
              <img
                :src="
                  require(`../../../assets/images/tai-xiu/assets/dice-3-active.png`)
                "
                width="18%"
              />
            </div>
            <div>
              <img
                :src="
                  require(`../../../assets/images/tai-xiu/assets/dice-4-active.png`)
                "
                width="18%"
              />
            </div>
            <div>
              <img
                :src="
                  require(`../../../assets/images/tai-xiu/assets/dice-5-active.png`)
                "
                width="18%"
              />
            </div>
            <div>
              <img
                :src="
                  require(`../../../assets/images/tai-xiu/assets/dice-6-active.png`)
                "
                width="18%"
              />
            </div>
          </Col>
          <Col
            class="tai-xiu-history-details-table-cell clickable"
            v-for="(col, index) in historicalData2"
            :key="index"
            :class="[index == 0 ? 'first' : '']"
          >
            <bet-history-popper
              :game="game"
              :table-name="tableName"
              :cell-data="col"
              :game-code="gameCode"
              :game-id="gameId"
            >
              <div>
                <span v-if="col.n1 === 1">x</span>
                <span v-if="col.n2 === 1">x</span>
                <span v-if="col.n3 === 1">x</span>
                <span v-if="col.n1 != 1 && col.n2 != 1 && col.n3 != 1">-</span>
              </div>
              <div>
                <span v-if="col.n1 === 2">x</span>
                <span v-if="col.n2 === 2">x</span>
                <span v-if="col.n3 === 2">x</span>
                <span v-if="col.n1 != 2 && col.n2 != 2 && col.n3 != 2">-</span>
              </div>
              <div>
                <span v-if="col.n1 === 3">x</span>
                <span v-if="col.n2 === 3">x</span>
                <span v-if="col.n3 === 3">x</span>
                <span v-if="col.n1 != 3 && col.n2 != 3 && col.n3 != 3">-</span>
              </div>
              <div>
                <span v-if="col.n1 === 4">x</span>
                <span v-if="col.n2 === 4">x</span>
                <span v-if="col.n3 === 4">x</span>
                <span v-if="col.n1 != 4 && col.n2 != 4 && col.n3 != 4">-</span>
              </div>
              <div>
                <span v-if="col.n1 === 5">x</span>
                <span v-if="col.n2 === 5">x</span>
                <span v-if="col.n3 === 5">x</span>
                <span v-if="col.n1 != 5 && col.n2 != 5 && col.n3 != 5">-</span>
              </div>
              <div>
                <span v-if="col.n1 === 6">x</span>
                <span v-if="col.n2 === 6">x</span>
                <span v-if="col.n3 === 6">x</span>
                <span v-if="col.n1 != 6 && col.n2 != 6 && col.n3 != 6">-</span>
              </div>
            </bet-history-popper>
          </Col>
        </Row>
      </Col>
    </Row>
  </div>
</template>

<script>
import { Row, Col } from "iview";
import { size, reduce, pickBy, toArray, reverse, forEach } from "lodash";
import { TweenLite, TimelineLite } from "gsap";
import BetHistoryPopper from "../widgets/BetHistoryPopper";
// import "gsap/TextPlugin.js";

export default {
  props: ["stat", "historicalData", "game", "gameCode", "gameId", "tableName"],
  components: {
    Row,
    Col,
    BetHistoryPopper,
  },
  data() {
    return {
      tempHistoricalData: [],
    };
  },
  computed: {
    historicalData2() {
      this.tempHistoricalData = toArray(this.historicalData);
      this.tempHistoricalData.splice(10);
      this.tempHistoricalData.reverse();
      this.triggerBlinkingEffect();
      return this.tempHistoricalData;
    },
  },
  watch: {},
  methods: {
    triggerBlinkingEffect() {
      this.$nextTick(() => {
        let animationTl = new TimelineMax();

        animationTl
          .to(
            "#game-" +
              this.gameId +
              " .tai-xiu-history-details-table-cell.clickable.ivu-col:last-of-type",
            0.5,
            {
              opacity: 0,
            }
          )
          .to(
            "#game-" +
              this.gameId +
              " .tai-xiu-history-details-table-cell.clickable.ivu-col:last-of-type",
            0.5,
            {
              opacity: 1,
            }
          );

        animationTl.repeat(4);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tai-xiu-history-details-row {
  margin: 15px 0;
}
.tai-xiu-history-details-table-title {
  flex: 10;
  background-color: $tai-xiu-theme-color-12;
  text-align: center;
  color: $tai-xiu-theme-color-4;
  font-weight: bold;
  border-right: 1px solid rgba($tai-xiu-theme-color-3, 10%);
  padding: 2px 0;
  font-size: 12px;
}

.tai-xiu-history-details-table-title:first-of-type {
  flex: 2;
}

.tai-xiu-history-details-table-cell {
  flex: 1;
  background-color: rgba($tai-xiu-theme-color-5, 20%);
  text-align: center;
  color: $tai-xiu-theme-color-4;
  border-right: 1px solid rgba($tai-xiu-theme-color-3, 10%);
  padding: 2px 0;
  font-size: 12px;
}

.tai-xiu-history-details-table-title:last-of-type,
.tai-xiu-history-details-table-cell:last-of-type {
  border-right: unset;
}

.tai-xiu-history-details-row-col {
  width: 100%;
}

.tai-xiu-history-details-table-title-row {
  border-bottom: 1px solid rgba($tai-xiu-theme-color-3, 10%);
}
.first {
  background: #e2e7f0;
}

.clickable:hover {
  cursor: pointer;
  background: #3374c2;
}
</style>
